import "core-js";
import * as React from "react";
import { ErrorBoundary } from "@appsignal/react";
import IBFApp from "./IBFApp";
import CompanyApp from "@apps/CompanyApp/CompanyApp";
import ProfileApp from "@apps/ProfileApp/ProfileApp";
import CompaniesDirectory from "@company/CompanyDirectory";
import ErrorPage from "@appComponents/ErrorPage/ErrorPage";
import ScrollToTop from "@company/components/HOC/ScrollToTop";
// import ErrorBoundary from "@appComponents/ErrorBoundary/ErrorBoundary";
import Notification from "@appComponents/Notification/Notification";
import store, { browserHistory } from "@features/store";
import { Provider } from "react-redux";
import { ConnectedRouter } from "react-router-redux";
import { Redirect, Route, Switch } from "react-router";
import { setApiMe, setAppSettings } from "@features/action.bfapp";
import { RailsPropsContext } from "@features/context";
import IProfileApp from "@apps/ProfileApp/IProfileApp";
import MessageApp from "@apps/MessageApp/MessageApp";
import { removeMultipleSlashes } from "@features/utils/functions";
import { MULTIPLE_SLASHES } from "@features/utils/regexpDefinitions";

import { appsignal } from "./appsignal";
import "antd/dist/antd.css";
import "./styles/overrideAntd.css";
import TermsAndConditionsApp from "./otherApps/TermsAndConditionsApp";
import MarketsApp from "@apps/MarketsApp";

class BFApp extends React.Component<IBFApp> {
  state = { loader: true };

  componentDidMount() {
    const pathname = window.location.pathname;
    if (MULTIPLE_SLASHES.test(pathname)) {
      window.location.href = removeMultipleSlashes(pathname);
      return;
    }

    store
      .dispatch(setAppSettings())
      .then(() => {
        store
          .dispatch(setApiMe(this.props.userSignedIn))
          .then(() => {
            this.setState({ loader: false });
          })
          .catch(() => {});
      })
      .catch(() => {});
  }

  render() {
    return (
      <ErrorBoundary instance={appsignal}>
        <Provider store={store}>
          <ConnectedRouter history={browserHistory}>
            <>
              <Notification />
              {!this.state.loader ? (
                <ScrollToTop>
                  <RailsPropsContext.Provider
                    value={{
                      verificationUrl: this.props.verificationUrl,
                    }}
                  >
                    <Switch>
                      <Route
                        path="/terms_and_conditions/:type?"
                        render={(props) => (
                          <TermsAndConditionsApp
                            userSignedIn={this.props.userSignedIn}
                            {...props}
                          />
                        )}
                      />

                      <Route
                        path="/(confirmations|requests)/:token"
                        render={(props) => (
                          <MessageApp
                            {...props}
                            messages={this.props.messages}
                            logoutButton={
                              !!this.props.messages.kyc ||
                              !!this.props.messages.us_compliance
                            }
                          />
                        )}
                      />
                      <Route
                        exact={true}
                        path="/companies"
                        render={(props) => <CompaniesDirectory {...props} />}
                      />
                      <Route
                        path="/companies/:slug"
                        render={(props) => (
                          <CompanyApp
                            investorId={this.props.investorId}
                            userSignedIn={this.props.userSignedIn}
                            match={props.match}
                            location={props.location}
                            slug={props.match.params.slug}
                            history={props.history}
                          />
                        )}
                      />

                      <Route
                        path="/market/:subpage?"
                        render={(props) => (
                          <MarketsApp
                            {...props}
                            investorId={this.props.investorId}
                            userSignedIn={this.props.userSignedIn}
                          />
                        )}
                      />

                      <Route
                        path="/search/pitches"
                        exact
                        render={(props) => (
                          <MarketsApp
                            {...props}
                            investorId={this.props.investorId}
                            userSignedIn={this.props.userSignedIn}
                          />
                        )}
                      />

                      {this.props.userSignedIn && (
                        <Route
                          path="/profile/:slug"
                          render={(props) => (
                            <ProfileApp
                              {...props}
                              {...(this.props as IProfileApp)}
                            />
                          )}
                        />
                      )}
                      <Route path="/error/:errorCode" component={ErrorPage} />
                      <Redirect exact from="/" to="/companies" />
                    </Switch>
                  </RailsPropsContext.Provider>
                </ScrollToTop>
              ) : null}
            </>
          </ConnectedRouter>
        </Provider>
      </ErrorBoundary>
    );
  }
}

export default BFApp;
